import axios from "axios";
import Qs from "qs";
import Bus from "@/assets/js/bus";

import { Message } from "element-ui";
import { lang } from "@/assets/lang/en";
import $store from "@/store/index.js";
import Tool from "@/assets/js/common/utils.js";
// http request 拦截器
let protocol = document.location.protocol === "https:" ? "https://" : "http://"; //获取协议
// 设置默认超时时间为15s， timeoutTips设置为true，会有请求超时的提示，默认不提示
axios.defaults.withCredentials = true;
// axios.defaults.timeout = 15000;
// console.log(axios.defaults);

// 用于连续多次点击时，取消之前的请求，之保留最后一次的请求状态
let pending = []; //声明一个数组用于存储每个正在pending的状态请求
let cancelToken = axios.CancelToken;
let removePending = (config, str) => {
  for (let i in pending) {
    if (pending[i].u === config.url + "&" + config.method) {
      //当 当前请求在数组中存在时执行函数体
      pending[i].f(); //执行取消操作
      pending.splice(i, 1);
    }
  }
};

let internetStatus = true; // true => 代表在线  false => 代表离线

window.addEventListener("online", () => {
  internetStatus = true;
});
window.addEventListener("offline", () => {
  internetStatus = false;
});

axios.interceptors.request.use(
  (config) => {
    if (!internetStatus) {
      //代表离线 给提示

      return false;
    }
    if (config.isCancelToken) {
      removePending(config, "request"); //在一个axios发送前执行一下取消操作
      config.cancelToken = new cancelToken((cancel) => {
        // 这里的axios标识用请求地址&请求方式拼接的字符串
        pending.push({ u: config.url + "&" + config.method, f: cancel });
      });
    }

    config.headers.Authorization = Tool.getCookie();
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
).time;

axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config.isCancelToken) {
      removePending(response.config, "response"); //在一个axios响应后再执行一下取消操作，把已经完成的请求从pending中移除
    }
    if (response.status == 200) {
      // response.data.errorCode = '810000015';
      if (lang[response.data.errorCode]) {
        Message({
          message: i18n.t(`lang.${response.data.errorCode}`),
          type: "error",
          customClass: "mzindex",
        });
      }
    }
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 406:
        case 402:
        case 401:
          if (error.response.data.result) {
            $store.commit("setSession", ""); //清空当前session
            window.localStorage.setItem("session", "");
            Tool.removeCookie();
            let userServiceUrl = $store.config
              ? $store.config.userServiceUrl
              : null;
            if (!userServiceUrl) {
              window.location.href = `${error.response.data.result}?url=${location.protocol}//${location.host}/&serviceName=Producer`;
            } else {
              window.location.href = `${protocol}${userServiceUrl}?url=${location.protocol}//${location.host}/&serviceName=Producer`;
            }
          }
          break;
        // 超时
        case 504:
          Message({
            message: i18n.t("lang.serverFailed"),
            type: "error",
          });
          break;
      }
      // 服务器异常处理
      if (
        (error.response.status + "").substr(0, 1) == "5" &&
        error.response.status != 504
      ) {
        Message({
          message: i18n.t("lang.serverFailed"),
          type: "error",
        });
      }
    }
    if (error.message && error.message.includes("timeout")) {
      // timeoutTips设置为true，会有请求超时的提示，默认不提示
      // if (error.config.timeoutTips) {
      Message({
        message: i18n.t("lang.timeOut"),
        type: "error",
      });
      // }
    }
    return Promise.reject(error.response);
  }
);
export default axios;
